import React, { forwardRef, useEffect, useState, useRef } from "react";
import "./reciptePrint.scss";
import { formatDate } from "../../../../common/Validations";
// import { CardGroup } from "react-bootstrap";

const ReceiptPrintOut = forwardRef((props, ref) => {
  const [data, setData] = useState(null);

  const contentRef = useRef(null);

  // useEffect(() => {
  //   if (props?.data) {
  //     let updatedData = { ...props.data };

  //     // If cartage flag is true, remove header level cartage fields
  //     if (props?.cartage === true) {
  //       delete updatedData.cartage;
  //       delete updatedData.salesCartage;
  //       delete updatedData.rentCartage;
  //       // delete updatedData.installationCharges;
  //     }
  //     if (props?.balanceSecurityAmt === true) {
  //       updatedData.balanceSecurityAmt = 0;
  //     }
  //     setData(updatedData);
  //   }
  // }, [props]);

  useEffect(() => {
    if (props?.data) {
      let updatedData = { ...props.data };

      if (props?.cartage === true) {
        delete updatedData.cartage;
        delete updatedData.salesCartage;
        delete updatedData.rentCartage;
      }
      if (props?.balanceSecurityAmt === true) {
        updatedData.balanceSecurityAmt = 0;
      }

      if (props?.isExtension === true) {
        updatedData.saleItems = [];
        updatedData.receivedSecurityAmt = 0;
        updatedData.installationCharges = 0;
      }

      // Hide rent items that are closed (collected at ERF closure) or physically returned
      if (updatedData.rentItems) {
        updatedData.rentItems = updatedData.rentItems.filter(
          (item) =>
            item?.extensionStatus !== "Closed" &&
            item?.productReturned !== true,
        );
      }
      // Hide sale items that are physically returned
      if (updatedData.saleItems) {
        updatedData.saleItems = updatedData.saleItems.filter(
          (item) => item?.productReturned !== true,
        );
      }
      setData(updatedData);
    }
  }, [props]);

  const today = new Date();
  const day = String(today.getDate()).padStart(2, "0");
  const month = String(today.getMonth() + 1).padStart(2, "0");
  const year = today.getFullYear();
  const currentDate = `${day}/${month}/${year}`;

  // Sales calculations
  const totalSalesQuantity = data?.saleItems?.reduce(
    (acc, item) => acc + Number(item?.orderedQuantity || 0),
    0,
  );
  const totalRentQuantity = data?.rentItems?.reduce(
    (acc, item) => acc + Number(item?.orderedQuantity || 0),
    0,
  );
  const totalSalesUnitPrice = data?.saleItems?.reduce(
    (acc, item) => acc + Number(item?.grossValue || 0),
    0,
  );
  const totalSalesPriecRounded = Math.round(totalSalesUnitPrice);

  const totalRentUnitPrice = data?.rentItems?.reduce(
    (acc, item) => acc + Number(item?.grossValue || 0),
    0,
  );
  const totalRentRoundedPrice = Math.round(totalRentUnitPrice);

  const totalNursingQuantity = data?.nursingItems?.reduce(
    (acc, item) => acc + Number(item?.orderedQuantity || 0),
    0,
  );
  const totalNursingUnitPrice = data?.nursingItems?.reduce(
    (acc, item) => acc + Number(item?.grossValue || 0),
    0,
  );
  const totalNursingRounded = Math.round(totalNursingUnitPrice || 0);

  const totalServiceQuantity = data?.serviceItems?.reduce(
    (acc, item) => acc + Number(item?.orderedQuantity || 0),
    0,
  );
  const totalServiceUnitPrice = data?.serviceItems?.reduce(
    (acc, item) => acc + Number(item?.grossValue || 0),
    0,
  );
  const totalServiceRounded = Math.round(totalServiceUnitPrice || 0);

  //   const latestCreditNote = data?.creditNoteHistory
  //   ?.filter((item) => item?.status === "Credit Note")
  //   ?.at(-1);

  // const latestRefund = data?.creditNoteHistory
  //   ?.filter((item) => item?.status === "Refund")
  //   ?.at(-1);

  // // ✅ Sum all Credit Note entries
  // const creditAmt = Math.round(
  //   (data?.creditNoteHistory || [])
  //     .filter((item) => item?.status === "Credit Note")
  //     .reduce((acc, item) => acc + (Number(item?.amount) || 0), 0),
  // );

  // // ✅ Sum all Refund entries
  // const refundAmt = Math.round(
  //   (data?.creditNoteHistory || [])
  //     .filter((item) => item?.status === "Refund")
  //     .reduce((acc, item) => acc + (Number(item?.amount) || 0), 0),
  // );

  // const balanceAmt = Math.round(data?.netAmount) - creditAmt - refundAmt;

  const creditNotes = (data?.creditNoteHistory || []).filter(
    (item) => item?.status === "Credit Note",
  );

  // Total for display — billing + security combined
  const creditAmt = Math.round(
    creditNotes.reduce((acc, item) => acc + (Number(item?.amount) || 0), 0),
  );

  // Only billing-type reduces the net balance
  const billingCreditAmt = Math.round(
    creditNotes
      .filter((item) => item?.amountType === "Billing")
      .reduce((acc, item) => acc + (Number(item?.amount) || 0), 0),
  );

  // Only security-type reduces the security balance
  const securityCreditAmt = Math.round(
    creditNotes
      .filter((item) => item?.amountType === "Security")
      .reduce((acc, item) => acc + (Number(item?.amount) || 0), 0),
  );

  const refundAmt = Math.round(
    (data?.creditNoteHistory || [])
      .filter((item) => item?.status === "Refund")
      .reduce((acc, item) => acc + (Number(item?.amount) || 0), 0),
  );

  const balanceAmt =
    Math.round(data?.netAmount || 0) - billingCreditAmt - refundAmt;
  const displayBalanceSecurityAmt =
    Math.round(data?.balanceSecurityAmt || 0) - securityCreditAmt;

  const showSaleTable = ["SL", "SLRE"].includes(data?.erfTypeCode);
  const showRentTable = ["RE", "SLRE"].includes(data?.erfTypeCode);
  const showNursingTable = data?.erfTypeCode === "NR";
  const showServiceTable = data?.erfTypeCode === "SV";

  const renderReceiptContent = (copyType) => (
    <div className="receipt-copy-wrapper">
      <div className="flex justify-between items-start mb-2">
        <div className="col-12">
          <div className="text-xs text-gray-600">Cash Receipt</div>
          <div className="col-12">
            <img
              src="/assets/img/medirent/printoutimage/deliverychallan.png"
              alt="Medical Equipment Header"
              className="header-img"
            />
          </div>
        </div>
      </div>

      <div className="grid grid-cols-3 gap-2 text-xs mb-2">
        <div className="flex">
          <span className="font-semibold">Receipt No.:</span>
          <span className="ml-2">{data?.receiptNo || "--"}</span>
        </div>
        <div className="flex">
          <span className="font-semibold">Sale Bill No.:</span>
          <span className="ml-2">--</span>
        </div>
        <div className="flex">
          <span className="font-semibold">Date :</span>
          <span className="ml-2 font-bold">{currentDate}</span>
        </div>
      </div>

      <div className="grid grid-cols-3 gap-2 text-xs mb-2">
        <div className="flex">
          <span className="font-semibold">Sale Point :</span>
          <span className="ml-2">{data?.salePoint}</span>
        </div>
        <div className="flex">
          <span className="font-semibold">Rent Bill No.:</span>
          <span className="ml-2">--</span>
        </div>
        <div className="flex">
          <span className="font-semibold">ERF No : </span>
          <span className="ml-2">{data?.equipmentRentNr}</span>
        </div>
      </div>

      <div className="flex gap-2 mb-2 border border-black rounded p-2">
        <div className="flex-1">
          <div className="mb-2">
            <div className="flex text-xs mb-1 border-b border-dotted border-gray-600">
              <span className="italic">Received From Mr./Mrs.</span>
              <span className="ml-2 font-bold truncate">
                {data?.patientName}
              </span>
              <span className="ml-auto">
                <span className="italic">Rs.</span>{" "}
                {/* <span className="font-bold">{Math.round(data?.netAmount)}</span> */}
                <span className="font-bold">{balanceAmt}</span>
              </span>
              <span className="ml-auto italic">By</span>
            </div>
            <div className="flex text-xs mb-1 items-center border-b border-dotted border-gray-600">
              <span className="mr-2 italic">Transaction No.</span>
              <span className="flex-1"></span>
              <span className="mx-2 italic">Dated :</span>
              <span className="flex-1"></span>
              <span className="ml-2 italic">Bank</span>
            </div>
            <div className="text-xs text-center mb-1 border-b border-dotted border-gray-600">
              <span className="mr-2 italic">Ref By:</span>
              <span className="font-semibold">NA</span>
            </div>
            <div className="text-xs mb-1 border-b border-dotted border-gray-600">
              <span className="italic">Address :</span>
              <span className="ml-2 italic truncate">
                {data?.billingAddress +
                  " " +
                  data?.billingState +
                  "-" +
                  data?.billingPinCode}
              </span>
            </div>
            <div className="text-xs border-b border-dotted border-gray-600">
              <span className="italic">
                On A/c of following product & services :
              </span>
              <span className="ml-2 text-xs">
                Duration from :{" "}
                <span className="font-bold">
                  {props?.balanceSecurityAmt
                    ? formatDate(data?.startingDate)
                    : formatDate(data?.erfStartDate)}
                </span>{" "}
                To :{" "}
                <span className="font-bold">
                  {props?.balanceSecurityAmt
                    ? formatDate(data?.endingDate)
                    : formatDate(data?.erfEndDate)}
                </span>
              </span>
            </div>
          </div>

          {/* Sales Items Table */}
          {showSaleTable && (
            <table className="items-table mb-1">
              <thead>
                <tr>
                  <th className="text-left">Sold Product</th>
                  <th className="text-left">Barcode</th>
                  <th className="text-center">Unit</th>
                  <th className="text-right">Amount</th>
                  <th className="text-left">Status</th>
                </tr>
              </thead>
              <tbody>
                {data?.saleItems?.map((item, index) => (
                  <tr key={index}>
                    <td className="truncate">{item?.materialDescription}</td>
                    <td>{item?.barcode}</td>
                    <td className="text-center">{item?.orderedQuantity}</td>
                    <td className="text-right">{item?.grossValue}</td>
                    <td>
                      {item?.creditNoteStatus ? "Credit Note" : "--" || "--"}
                    </td>
                  </tr>
                ))}
                <tr className="total-row">
                  <td colSpan="2" className="font-semibold">
                    Total
                  </td>
                  <td className="text-center">{totalSalesQuantity}</td>
                  <td className="text-right font-bold">
                    {totalSalesUnitPrice}
                  </td>
                  <td></td>
                </tr>
              </tbody>
            </table>
          )}

          {/* Rental Items Table */}
          {showRentTable && (
            <table className="items-table">
              <thead>
                <tr>
                  <th className="text-left">Rented Product</th>
                  <th className="text-left">Barcode</th>
                  <th className="text-center">Unit</th>
                  <th className="text-right">Amount</th>
                  <th className="text-left">Status</th>
                </tr>
              </thead>
              <tbody>
                {data?.rentItems?.map((item, index) => (
                  <tr key={index}>
                    <td className="truncate">{item?.materialDescription}</td>
                    <td>{item?.barcode}</td>
                    <td className="text-center">{item.orderedQuantity}</td>
                    <td className="text-right">{item.grossValue}</td>
                    <td>
                      {item?.creditNoteStatus ? "Credit Note" : "--" || "--"}
                    </td>
                  </tr>
                ))}
                <tr className="total-row">
                  <td colSpan="2" className="font-semibold">
                    Total
                  </td>
                  <td className="text-center">
                    {Math.round(Number(totalRentQuantity) || 0)}
                  </td>
                  <td className="text-right font-bold">
                    {totalRentRoundedPrice}
                  </td>
                  <td></td>
                </tr>
              </tbody>
            </table>
          )}

          {/* Nursing Items Table */}
          {showNursingTable && (
            <table className="items-table mb-1">
              <thead>
                <tr>
                  <th className="text-left">Nursing Service</th>
                  <th className="text-left">Barcode</th>
                  <th className="text-center">Unit</th>
                  <th className="text-right">Amount</th>
                  <th className="text-left">Status</th>
                </tr>
              </thead>
              <tbody>
                {data.nursingItems.map((item, index) => (
                  <tr key={index}>
                    <td className="truncate">{item?.materialDescription}</td>
                    <td>{item?.barcode}</td>
                    <td className="text-center">{item?.orderedQuantity}</td>
                    <td className="text-right">{item?.grossValue}</td>
                    <td>
                      {item?.creditNoteStatus ? "Credit Note" : "--" || "--"}
                    </td>
                  </tr>
                ))}
                <tr className="total-row">
                  <td colSpan="2" className="font-semibold">
                    Total
                  </td>
                  <td className="text-center">{totalNursingQuantity}</td>
                  <td className="text-right font-bold">
                    {totalNursingRounded}
                  </td>
                  <td></td>
                </tr>
              </tbody>
            </table>
          )}

          {/* Service Items Table — shown only for Service ERF */}
          {showServiceTable && (
            <table className="items-table mb-1">
              <thead>
                <tr>
                  <th className="text-left">Service Product</th>
                  <th className="text-left">Barcode</th>
                  <th className="text-center">Unit</th>
                  <th className="text-right">Amount</th>
                  <th className="text-left">Status</th>
                </tr>
              </thead>
              <tbody>
                {data.serviceItems.map((item, index) => (
                  <tr key={index}>
                    <td className="truncate">{item?.materialDescription}</td>
                    <td>{item?.barcode}</td>
                    <td className="text-center">{item?.orderedQuantity}</td>
                    <td className="text-right">{item?.grossValue}</td>
                    <td>
                      {item?.creditNoteStatus ? "Credit Note" : "--" || "--"}
                    </td>
                  </tr>
                ))}
                <tr className="total-row">
                  <td colSpan="2" className="font-semibold">
                    Total
                  </td>
                  <td className="text-center">{totalServiceQuantity}</td>
                  <td className="text-right font-bold">
                    {totalServiceRounded}
                  </td>
                  <td></td>
                </tr>
              </tbody>
            </table>
          )}
        </div>

        {/* Financial Summary */}
        <div className="summary-box">
          <div className="summary-content">
            {[
              // ["Sale Amount", totalSalesPriecRounded],
              // ["Rental Amount", totalRentRoundedPrice],
              [
                "Sale Amount",
                showServiceTable ? totalServiceRounded : totalSalesPriecRounded,
              ],
              [
                "Rental Amount",
                showNursingTable ? totalNursingRounded : totalRentRoundedPrice,
              ],

              ["Cartage", data?.cartage || 0],
              ["Install. Charges", data?.installationCharges || 0],
              ["Net Amt.", Math.round(data?.netAmount)],
              ["Received Amt.", data?.receivedAmount],
              //["Credit Amt.", Math.round(latestCreditNote?.amount ?? 0)],
              //["Refund Amt.", Math.round(latestRefund?.amount ?? 0)],
              ["Credit Amt.", creditAmt],
              ["Refund Amt.", refundAmt],
              ["Balance Amt.", balanceAmt],
              ["Security Details", "0"],
              ["Received Sec Amt.", Math?.round(data?.receivedSecurityAmt)],
              // ["Bal. Security Amt.", data?.balanceSecurityAmt],
               ["Bal. Security Amt.", displayBalanceSecurityAmt],
              ["Return Amt.", "0"],
            ].map(([label, value], index) => (
              <div key={index} className="summary-row">
                <span>{label}</span>
                <span>:</span>
                <span className="font-bold">{value}</span>
              </div>
            ))}
            <div className="summary-divider"></div>
            <div className="signature-text">Payee's Signature</div>
            <div>
              Contact No. :{" "}
              <span className="font-bold">
                {data?.mobileNr
                  ? "X".repeat(String(data.mobileNr).length - 2) +
                    String(data.mobileNr).slice(-2)
                  : "--"}
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Footer */}
      <div className="footer-section">
        <div className="terms">
          <div className="font-bold mb-1">Terms & Conditions:</div>
          <div>1) Please check the order receipt and products on demand.</div>
          <div>2) Payment by cheque is subject to realisation.</div>
          <div>3) Rental collection visits are charged.</div>
          <div>
            4) In case of Refund, Refunds will be processed within 2 to 3
            working days.
          </div>
          <div>5) Refunds will be processed "online" only.</div>
          <div className="italic mt-1">info@medirent.in</div>
        </div>
        <div className="copy-type">
          <div className="font-bold">{copyType}</div>
          <div className="mt-2">Pass To: MID - HO Gurugram</div>
        </div>
        <div className="signature">
          <div className="font-bold">For MEDIRENT SERVICE PVT. LTD.</div>
          <div className="mt-2">
            SE <span className="signature-line"></span> (Authorized Signatory)
          </div>
          <div className="italic mt-1">www.medirent.in</div>
        </div>
      </div>
      <div className="disclaimer">
        All disputes are subject to Jurisdiction Delhi Courts Exclusively
      </div>
    </div>
  );

  return (
    <div ref={ref} className="print-container">
      <div className="single-page-content" ref={contentRef}>
        {renderReceiptContent("Customer Copy")}
        <div className="copy-separator"></div>
        {renderReceiptContent("Office Copy")}
      </div>
    </div>
  );
});

export default ReceiptPrintOut;
